var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('HeaderTop',{on:{"show-minimal":_vm.showMinimal}}),_c('hr'),_c('HeaderBottom',{directives:[{name:"show",rawName:"v-show",value:(_vm.minimal === false),expression:"minimal === false"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }